import { render, staticRenderFns } from "./ship-info.vue?vue&type=template&id=103e58cb&scoped=true&"
import script from "./ship-info.vue?vue&type=script&lang=js&"
export * from "./ship-info.vue?vue&type=script&lang=js&"
import style0 from "./ship-info.vue?vue&type=style&index=0&id=103e58cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103e58cb",
  null
  
)

export default component.exports